import { FC, useCallback, useEffect, useState } from 'react';

import { useRouter } from 'next/router';

import { useMediaQuery } from '@mui/material';

import { Element } from 'react-scroll';
import { useRecoilValue, useSetRecoilState } from 'recoil';

import { isInMobileContactRoomFlag } from '@recoil_iqfu/atoms/chat/talk/isInMobileContactRoomFlag';
import { isInMobileTalkRoomFlag } from '@recoil_iqfu/atoms/chat/talk/isInMobileTalkRoomFlag';
import { spMenuOpenAtom } from '@recoil_iqfu/atoms/side_menu/spMenuOpen';

import ProtectedRoutes from '@components_common/protected_routes/ProtectedRoutes';
import UserButton from '@components_common/user_button/UserButton';
import { MediaQuery, UserType } from '@constants_common';
import { useWindowSize } from '@hooks_common/useWindowSize';

import styles from './ConsoleChatPageContainer.module.scss';

type Props = {
  limitHeightToWindowHeight?: boolean;
  userType: UserType;
};

const ConsoleChatPageContainer: FC<Props> = ({ limitHeightToWindowHeight = true, userType, children }) => {
  const router = useRouter();

  const spMenuOpen = useRecoilValue(spMenuOpenAtom);

  const [containerStyle, setContainerStyle] = useState({ height: 'auto' });
  const isMobile = useMediaQuery(MediaQuery.lg);
  const { height: windowHeight, width: windowWidth } = useWindowSize();

  const [userInfoHeaderHeight, setUserInfoHeaderHeight] = useState(0);

  const setIsInMobileTalkRoom = useSetRecoilState(isInMobileTalkRoomFlag);
  const setIsInMobileContactRoom = useSetRecoilState(isInMobileContactRoomFlag);

  //useCallBackでとらないと高さとれないhttps://stackoverflow.com/questions/60476155/is-it-safe-to-use-ref-current-as-useeffects-dependency-when-ref-points-to-a-dom
  const handleUserInfoHeaderHeight = useCallback(
    (node: any) => {
      setUserInfoHeaderHeight(node?.getBoundingClientRect().height);
    },
    [windowWidth],
  );

  useEffect(() => {
    if (limitHeightToWindowHeight) {
      setContainerStyle({ height: `${windowHeight - userInfoHeaderHeight}px` });
    }
  }, [windowHeight, userInfoHeaderHeight, limitHeightToWindowHeight]);

  useEffect(() => {
    if (
      (isMobile && router.pathname.includes('chat/talk') && router.query.roomId) ||
      (isMobile && router.pathname.includes('chat/seller_consulting') && router.query.roomId) ||
      (isMobile && router.pathname.includes('chat/seller_contact') && router.query.roomId)
    ) {
      setIsInMobileTalkRoom(true);
    } else {
      setIsInMobileTalkRoom(false);
    }
    if (isMobile && router.pathname.includes('chat/contact') && router.query.roomId) {
      setIsInMobileContactRoom(true);
    } else {
      setIsInMobileContactRoom(false);
    }
  }, [router, isMobile]);

  return (
    <ProtectedRoutes userType={userType}>
      <div className={`${styles.container} ${spMenuOpen ? styles.is_sp_menu_open : ''}`}>
        <div className={styles.user_header_container} ref={handleUserInfoHeaderHeight}>
          <UserButton userType={userType} isChat={true} />
        </div>
        <div className={styles.main_container} style={containerStyle} id="chat_page_container">
          <Element name="container_top"></Element>
          {!spMenuOpen && <>{children}</>}
        </div>
      </div>
    </ProtectedRoutes>
  );
};

export default ConsoleChatPageContainer;
